import z from "zod";

export const geosSchema = z.object({
  value: z.string().optional(),
  type: z.string().optional(),
});
